module.exports = __webpack_public_path__ + "img/ic-rayures.469b33f4.svg";